export const crmCreatePageContent = {
  "how-to-create-crm": {
    title: "How to create CRM in anydone?",
    content: `
        <p>
        In anydone, you first need to create a project(if you haven’t created one already). Within the project, you must create a CRM folder, first. Once the CRM folder is created, then you can create multiple CRMs as needed within that CRM folder.
        </p>
        <h3 class="headingThree">
        Step to create CRM folder:
        </h3>
        <ul class="steps-list">
          <li>Log in to your anydone account.</li>
          <li>Click on the <strong>Projects</strong> icon from the left side of your dashboard.<br>
          (If you haven’t created a project yet, learn how to create one and then come back and continue.)
          </li>
          <li>Navigate to the<strong>project</strong> where you want to create a <strong>CRM folder.</strong></li>
          <li>Click the <strong>+</strong> button from the bottom-right corner.</li>
          <li>Select<strong>CRM (AI First)</strong> from the options.</li>
          <li><strong>Name</strong>  your CRM folder.</li>
          <li>Click the <strong>Create</strong> button.</li>
          </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/3a175275-f308-4070-9a99-4b2b309c98c9.mp4"></video-component>
        <h3 class="headingThree">
            Once the CRM folder is created, follow the steps to create CRM.
        </h3>
        <ul class="steps-list">
          <li>Click on the <strong>CRM</strong> folder you just created.</li>
          <li>Click the <strong>+</strong> button from the bottom right corner.</li>
          <li>Enter a <strong>name</strong> and <strong>description</strong> for your CRM.</li>
          <li>Click the <strong>Create</strong> button.</li>
          <li>Once the <strong>CRM is created,</strong> click on it to <strong>access its dashboard.</strong></li>
          </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/fce73bb1-37ab-4192-9eeb-4747de346ff1.mp4"></video-component>
        <span>
            <strong>Tips: </strong> <br>
            <i class="fa-solid fa-arrow-right-long"></i> From <strong>CRM Folder >> CRM</strong>, click the three-dot menu on the right side of your CRM to <strong>Edit</strong> or <strong>Delete</strong> it.
        </span>
    `,
  },
  "managing-messages": {
    title: "Managing Messages and Priorities in anydone CRM",
    content: `
        <p>
        Anydone CRM Dashboard is user-friendly and designed to help you manage interactions and conversations efficiently from one single dashboard..
        </p>
        <i class="headingThree">
        Dashboard Overview
        </i>
        <image-component src="https://edge-a.anydone.com/treeleaf/c5d8047f-6e7f-4ad1-bcec-de7bfe8449af.png" alt="ai-powered-crm-anydone"></image-component>
        
        <p>
        <span class="underline-text">All Messages Panel: </span> On the left-hand side, under <strong>All Messages</strong>, you can view all of the names  and conversation. Notably, these conversations are flagged based on priority to help you handle incoming queries on priority basis. 
        </p>

        <h3 class="headingThree">
        Dashboard Overview
        </h3>
        <ul class="no-listing">
            <li>
            <span class="underline-text text-red">Red Flag</span> → Highest Priority
            </li>
            <li>
            <span class="underline-text text-yellow">Yellow Flag</span> → Medium Priority
            </li>
            <li>
            <span class="underline-text text-green">Green Flag</span> → Low Priority
            </li>
        </ul>
        <p>You can update priority flags manually</p>
    `,
  },
  "how-to-change-message": {
    title: "How to Change Message Priority",
    content: `
        <ul class="steps-list">
            <li>
            Navigate to the message thread you want to update and click on it.
            </li>
            <li>
            From the top-right corner, click on the dropdown button next to the flag.
            </li>
            <li>
            Select the new priority flag (Red, Yellow, or Green) as needed.
            </li>
        </ul>

        <video-component src="https://edge-a.anydone.com/treeleaf/fce73bb1-37ab-4192-9eeb-4747de346ff1.mp4"></video-component>
        <h2 class="headingThree">
        Additional Information:
        </h2>
        <p>Message priorities are auto-assigned by Anydone AI based on factors like query urgency, customer history, and keywords.</p>
    `,
  },
  "managing-spam-messages": {
    title: "Managing Spam Messages",
    content: `
    <p>
    Anydone's AI automatically detects and marks messages as Spam if they contain malicious content or irrelevant queries. Nevertheless, you can review and change it if needed.
    </p>

    <h2 class="headingThree">
        How to Mark a Message as Not Spam
    </h2>
    <ul class="steps-list">
        <li>
            Click on the message thread marked as Spam(need icon for this).
        </li>
        <li>
            From the text editor, click on the three-dot menu in the top-right corner.
        </li>
        <li>
            Select Mark as Not Spam from the given options.
        </li>
    </ul>

    <video-component src="https://edge-a.anydone.com/treeleaf/ac43182b-57b9-4106-b802-3eed77841d11.mp4"></video-component>
    `,
  },
};
